"use strict";

var m = Object.create;
var l = Object.defineProperty;
var f = Object.getOwnPropertyDescriptor;
var v = Object.getOwnPropertyNames;
var w = Object.getPrototypeOf,
  C = Object.prototype.hasOwnProperty;
var u = (r, o) => {
    for (var e in o) l(r, e, {
      get: o[e],
      enumerable: !0
    });
  },
  c = (r, o, e, t) => {
    if (o && typeof o == "object" || typeof o == "function") for (let n of v(o)) !C.call(r, n) && n !== e && l(r, n, {
      get: () => o[n],
      enumerable: !(t = f(o, n)) || t.enumerable
    });
    return r;
  };
var x = (r, o, e) => (e = r != null ? m(w(r)) : {}, c(o || !r || !r.__esModule ? l(e, "default", {
    value: r,
    enumerable: !0
  }) : e, r)),
  R = r => c(l({}, "__esModule", {
    value: !0
  }), r);
var W = {};
u(W, {
  ChevronRightIcon: () => a
});
module.exports = R(W);
var i = x(require("react")),
  d = require("@twilio-paste/uid-library"),
  g = require("./helpers/IconWrapper");
const a = i.forwardRef((_ref, I) => {
  let {
    as: r,
    display: o,
    element: e = "ICON",
    size: t,
    color: n,
    title: p,
    decorative: s
  } = _ref;
  const h = "ChevronRightIcon-".concat((0, d.useUID)());
  if (!s && p == null) throw new Error("[ChevronRightIcon]: Missing a title for non-decorative icon.");
  return i.createElement(g.IconWrapper, {
    as: r,
    display: o,
    element: e,
    size: t,
    color: n,
    ref: I
  }, i.createElement("svg", {
    role: "img",
    "aria-hidden": s,
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 20 20",
    "aria-labelledby": h
  }, p ? i.createElement("title", {
    id: h
  }, p) : null, i.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.707 6.293a1 1 0 00-1.497 1.32l.083.094L10.585 10l-2.292 2.293a1 1 0 00-.083 1.32l.083.094a1 1 0 001.32.083l.094-.083 3-3a1 1 0 00.083-1.32l-.083-.094-3-3z"
  })));
});
a.displayName = "ChevronRightIcon";